import styled from "styled-components";

export const ForgotPasswordWrapper = styled.div`
    height: calc(100vh - 271px);
    form{
        width: 600px;
    }
    .btn-forgot{
        height: 40px;
    }
    
`
